// src/services/informedConsentApi.js
// Servicio para consentimiento informado (CRUD)

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Lista consentimientos con filtros
 * @param {Object} params - appointment_id, limit, offset
 * @returns {Promise<Object>}
 */
export const getInformedConsents = async (params = {}) => {
  try {
    const searchParams = new URLSearchParams(params);
    const response = await dotoniwoofApi.get(`/informedConsent.php?${searchParams.toString()}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al listar consentimientos' }
    };
  }
};

/**
 * Obtiene el consentimiento por id de cita
 * @param {number} appointmentId - ID de la cita
 * @returns {Promise<Object>}
 */
export const getInformedConsentByAppointment = async (appointmentId) => {
  try {
    const response = await dotoniwoofApi.get(
      `/informedConsent.php?action=by-appointment&appointment_id=${appointmentId}`
    );
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al obtener consentimiento' }
    };
  }
};

/**
 * Obtiene un consentimiento por ID
 * @param {number} id - ID del consentimiento
 * @returns {Promise<Object>}
 */
export const getInformedConsentById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`/informedConsent.php/${id}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al obtener consentimiento' }
    };
  }
};

/**
 * Crea un consentimiento informado
 * @param {Object} body - id_appointment, url_pdf_firebase, physical_condition, behavior_notes, last_vaccination_date, additional_notes, signed_by_person (opcional)
 * @returns {Promise<Object>}
 */
export const createInformedConsent = async (body) => {
  try {
    const response = await dotoniwoofApi.post('/informedConsent.php', body);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al crear consentimiento' }
    };
  }
};

/**
 * Actualiza un consentimiento informado
 * @param {number} id - ID del consentimiento
 * @param {Object} body - Campos a actualizar
 * @returns {Promise<Object>}
 */
export const updateInformedConsent = async (id, body) => {
  try {
    const response = await dotoniwoofApi.put(`/informedConsent.php/${id}`, body);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al actualizar consentimiento' }
    };
  }
};

/**
 * Elimina un consentimiento informado
 * @param {number} id - ID del consentimiento
 * @returns {Promise<Object>}
 */
export const deleteInformedConsent = async (id) => {
  try {
    const response = await dotoniwoofApi.delete(`/informedConsent.php/${id}`);
    return { ok: true, status: response.status, data: response.data };
  } catch (error) {
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al eliminar consentimiento' }
    };
  }
};
